import { Controller } from "@hotwired/stimulus"

// Automatically removes an element after a delay (default 5 seconds).
// Usage: data-controller="auto-dismiss" data-auto-dismiss-delay-value="5000"
export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.timeout = setTimeout(() => {
      this.element.style.transition = "opacity 300ms ease-out"
      this.element.style.opacity = "0"
      setTimeout(() => this.element.remove(), 300)
    }, this.delayValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }
}
